module.exports = __webpack_public_path__ + "static/ravnica-tavern-d94c49d33076ad6a45f44ca34c1744d8.jpg";